import { useSearchParams } from 'react-router-dom';

export const useCopCountries = () => {
  const [searchParams] = useSearchParams();
  const countryCode = searchParams.get('countryCode');
  const isCopCountries = (params?: { exception?: string[] }) =>
    (countryCode === 'DE' ||
      countryCode === 'UK' ||
      countryCode === 'FR' ||
      countryCode === 'ES' ||
      countryCode === 'IT' ||
      countryCode === 'IN') &&
    !params?.exception?.includes(countryCode);
  return { isCopCountries };
};
